import React, { createContext, useContext } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProjectDetailPage from './components/ProjectDetailPage';
import CoreSellPage from './pages/CoreSellPage';

// Contact Context
const ContactContext = createContext();

export const useContact = () => {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error('useContact must be used within ContactProvider');
  }
  return context;
};

function App() {
  const contactdetail = {
    tel: "09134378347",
    adres: "اصفهان, خیابان کاوه",
    email: "info@altostudio.ir",
    telegram: "https://t.me/altostudio_net",
    instagram: "https://www.instagram.com/altostudio_net",
    facebook: "https://www.facebook.com/altostudio_net",
    twitter: "https://www.twitter.com/altostudio_net",
    whatsapp: "https://wa.me/09134378347",
  }

  return (
    <ContactContext.Provider value={contactdetail}>
      <HashRouter>
        <div className="min-h-screen bg-slate-900">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/coresell" element={<CoreSellPage />} />
            <Route path="/project/:id" element={<ProjectDetailPage />} />
          </Routes>
        </div>
      </HashRouter>
    </ContactContext.Provider>
  );
}

export default App;
